
import {Component, EventEmitter, Input, OnInit, OnDestroy, Output, ViewChildren, QueryList} from '@angular/core';
import {FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import {Subscription as RxJsSubscription} from 'rxjs';
import {ErrorService, ExplainErrorsService, SessionService} from '@app/services';
import { environment } from '@env/environment';
import {Category} from '../category';
import {CategoryService} from '../category.service';
import { LanguageTabComponent } from '@app/models/language';
@Component({
  selector: 'hpf-category-form',
  templateUrl: './category-form.component.html'
})
export class CategoryFormComponent implements OnInit, OnDestroy {
  /** The model subscription */
  private modelSubscription: RxJsSubscription;
  /** The category to inject in the form */
  @Input() category: Category;
  /** Called the save button is clicked for a new instance */
  @Output() create = new EventEmitter<Category>();
  /** Called the save button is clicked for an existing instance */
  @Output() update = new EventEmitter<void>();
  /** Called the delete button is clicked */
  @Output() delete = new EventEmitter<void>();
  /** Set loading state of the form */
  @Input() loading = false;
  /** Enable the deletion button */
  @Input() deletable = true;
	/** Enabled quick form */
	@Input() quickFormEnabled = environment.plugins.quickForm.enabled;
  /** Denotes if deltion in progress */
  deleting = false;
  /** Show delete modal */
  deleteModal = false;
  /** The form group to use */
  form: FormGroup;
  /** Denotes if the form is pending */
  saving = false;
  /** Check permission of update **/
  readOnly = false;
	@ViewChildren(LanguageTabComponent) languageTabs: QueryList<
		LanguageTabComponent
	>;
  /** Constructor */
  constructor(private formBuilder: FormBuilder,
              private errorService: ErrorService,
              public explainErrorsService: ExplainErrorsService,
              private categoryService: CategoryService,
              private sessionService: SessionService) {
  }
  /** Init */
  async ngOnInit() {
    this.readOnly = !(await this.sessionService.checkPermission(
			'category',
			'update'
		));

    // Init model
    if(!this.category) this.category = new Category();

    // Create form
    this.form = this.formBuilder.group({
    name: new FormControl(this.category.props.name, [Validators.required]),
    image: new FormControl(this.category.props.image, [Validators.required]),

    order: new FormControl(this.category.props.order, [Validators.required]),
    });
    // Update form when model loads or changes
    this.modelSubscription = this.category.subscribe(() => {
        this.updateForm();
    });
  }
  /** Destroy */
  ngOnDestroy() {
    this.modelSubscription.unsubscribe();
  }
  /** Called on form submit */
  async onSubmit(): Promise<void> {
    // Saving flag
    this.saving = true;
    try {
        // Update model
        this.updateModel();
		for (let element of this.languageTabs) {
				await element.submit();
			}
        // Creation or update ?
        if (this.category.isNew()) {
            // Creation
            const category: Category = await this.categoryService.create(this.category.toPayload());
            this.create.next(category);
        } else {
            // Update
            await this.categoryService.update(this.category.getId(), this.category.toPayload());
            this.update.next();
        }
    } catch (error) {
        this.errorService.handle(error);
    }
    // Saving flag
    this.saving = false
  }
  /** Update models properties from inputs values */
  private updateModel(): void {
    for (const key of Object.keys(this.form.controls)) {
        this.category.props[key] = this.form.get(key).value;
    }
  }
  /** Update inputs values from models properties */
  private updateForm(): void {
    this.form.setValue({
      'name': this.category.props.name,   
      'image': this.category.props.image,   

      'order': this.category.props.order,   
    });
  }
  /** Called on deletion */
  onDelete(): void {
    this.deleting = true;
    this.categoryService.remove(this.category.getId())
      .then(() => {
        this.delete.next();
      })
      .catch((error) => this.errorService.handle(error))
      .then(() => this.deleting = false);
  }
}
